<template>
  <div>
    <section class="accordions">
      <article class="accordion" :class="{'is-active': newMessageVisible}">
        <div class="accordion-header toggle is-size-5" @click="newMessageVisible = !newMessageVisible">
          <a>Send message ⯆</a>
        </div>
        <div class="accordion-body">
          <div class="accordion-content has-background-dark has-text-white">
            <div class="field">
              <label class="label">Subject (for email)</label>
              <div class="control">
                <input class="input" type="text" v-model="newMessage.subject">
              </div>
            </div>
            <div class="field">
              <label class="label">Text</label>
              <div class="control">
                <textarea class="textarea" v-model="newMessage.text"></textarea>
              </div>
            </div>
            <div class="field">
              <label class="label">Phone number / Email</label>
              <div class="control">
                <input class="input oc-input" type="text" v-model="newMessage.address">
              </div>
            </div>
            <div class="field">
              <label class="label">Provider</label>
              <div class="control">
                <div class="select">
                  <select v-model="newMessage.provider">
                    <option>epochta</option>
                    <option>releans</option>
                    <option>komplexmessenger</option>
                    <option>zoho</option>
                    <option>opersms</option>
                    <option>mobivas</option>
                    <option>socnet</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label">Messenger</label>
              <div class="control">
                <div class="select">
                  <select v-model="newMessage.messenger">
                    <option>wa</option>
                    <option>vb</option>
                    <option>tg</option>
                    <option>sms</option>
                    <option>email</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <button class="button is-success" @click="sendMessage()" :disabled="!newMessage.text || !newMessage.address || !newMessage.messenger">Send</button>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>

    <table class="table is-fullwidth is-hoverable is-size-7">
      <thead>
        <tr>
          <th>Date</th>
          <th>Phone number / Email</th>
          <th>User</th>
          <th>Messenger</th>
          <th>Message</th>
          <th>Sent</th>
          <th>Error</th>
          <th>Service message ID</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="message in messages" :key="message.id">
          <td>{{message.date | datetime}}</td>
          <td>{{message.phoneNumber || message.email}}</td>
          <td>
            <router-link v-if="message.userId" :to="{ name: 'player', params: { clientId: clientId, playerId: message.userId } }" target="_blank">{{message.userId}}</router-link>
          </td>
          <td>{{message.messenger}}</td>
          <td>
            <b v-if="message.subject">{{message.subject}}</b>
            <p>{{message.message.length > 100 ? message.message.substr(0, 100) + '...' : message.message}}</p>
          </td>
          <td>
            <span v-if="message.isSent" class="tag is-success">sent</span>
            <span v-if="!message.isSent" class="tag is-danger">fail</span>
          </td>
          <td>{{message.errorMessage}}</td>
          <td>{{message.serviceMessageId}}</td>
        </tr>
      </tbody>
    </table>
    <pagination @change="loadMessages();" ref="pagination" />
  </div>
</template>
<script>
  import messageService from '../../../../services/message.service'
  import noty from '../../../../services/noty.service'

  import pagination from '../../../common/pagination.vue'

  export default {
    name: 'messages-list',
    components: { pagination },
    data() {
      return {
        messages: [],
        newMessage: {
          text: null,
          phoneNumber: null,
          messenger: null
        },
        newMessageVisible: false
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    watch: {
      async clientId() {
        await this.loadMessages();
      }
    },
    async mounted() {
      await this.loadMessages();
    },
    methods: {
      async loadMessages() {
        const filter = {
          pageNumber: this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize
        };
        const data = await messageService.getByClient(this.clientId, filter);
        this.messages = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      },
      async sendMessage() {
        this.newMessage.clientId = this.clientId;
        let result = await messageService.send(this.newMessage);
        if(result.isSuccess)
          noty.success('Message sent successfully');
        else
          noty.error('ERROR: ' + result.error);
        await this.loadMessages();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/messages/index.vue